import { AxiosPromise, AxiosRequestConfig } from "axios";
import { oc } from "ts-optchain";

import { IMockRouteConfig, Mockios } from "./Mockios";

import { IBackorderDto, IPartAlternativeDto, PartValidationReason, ShipmentType, Source } from "@/types";
import { IGetPartAlternativesRequest } from ".";
import { MockRouteMatcher } from "./MockRouteMatcher";

import { CONTROLLER_PATH } from "./BackorderService";

export class BackorderMockService {
    public static getRoutes(): IMockRouteConfig[] {
        return [
            {
                result: this.getBackordersForUserFactory,
                isMatch: (rq) =>
                    MockRouteMatcher.isMethodAndPathMatch("post", `${CONTROLLER_PATH}/LoadAllBackOrdersForUser`, rq),
            },
            {
                result: this.getPartAlternativeResultFactory,
                isMatch: (rq) =>
                    MockRouteMatcher.isMethodAndPathMatch("post", `${CONTROLLER_PATH}/AlternativesList`, rq),
            },
        ];
    }

    private static getBackordersForUserFactory(request: AxiosRequestConfig): AxiosPromise<IBackorderDto[]> {
        return Mockios.ok(request, [
            {
                SalesOrganization: "RP",
                LineFacingWarehouse: "",
                OrderBranch: "15310",
                SalesOrderNumber: "1000114376",
                SalesOrderLineNumber: "",
                PurchaseOrderNumber: "test123bb",
                OemPartCode: "2I6310",
                QuantityOrdered: 1,
                QuantityBackordered: 1,
                OrderType: ShipmentType.Emergency,
                OrderSource: Source.NotSet,
                PromisedShipDate: "2019-09-18T00:00:00",
                EstimatedVendorShipDate: "2019-09-18T00:00:00",
                AlternativesCount: 0,
                OrderDate: null,
            },
            {
                SalesOrganization: "MA",
                LineFacingWarehouse: "",
                OrderBranch: "15310",
                SalesOrderNumber: "7894634",
                SalesOrderLineNumber: "",
                PurchaseOrderNumber: "7890465",
                OemPartCode: "A000023428",
                QuantityOrdered: 1,
                QuantityBackordered: 1,
                OrderType: ShipmentType.Warranty,
                OrderSource: Source.Mcf,
                PromisedShipDate: "2019-09-18T00:00:00",
                EstimatedVendorShipDate: "2019-09-18T00:00:00",
                AlternativesCount: 3,
                OrderDate: "2019-09-18T00:00:00",
            },
            {
                SalesOrganization: "MA",
                LineFacingWarehouse: "",
                OrderBranch: "15310",
                SalesOrderNumber: "45667",
                SalesOrderLineNumber: "",
                PurchaseOrderNumber: "7894123",
                OemPartCode: "ELSA",
                QuantityOrdered: 1,
                QuantityBackordered: 1,
                OrderType: ShipmentType.Stock,
                OrderSource: Source.Rpi,
                PromisedShipDate: "2019-09-18T00:00:00",
                EstimatedVendorShipDate: "2019-09-18T00:00:00",
                AlternativesCount: 1,
                OrderDate: "2019-09-18T00:00:00",
            },
            {
                SalesOrganization: "MA",
                LineFacingWarehouse: "",
                OrderBranch: "15310",
                SalesOrderNumber: "45667",
                SalesOrderLineNumber: "",
                PurchaseOrderNumber: "7894123",
                OemPartCode: "BATMAN",
                QuantityOrdered: 1,
                QuantityBackordered: 1,
                OrderType: ShipmentType.Stock,
                OrderSource: Source.Rpi,
                PromisedShipDate: "2019-09-18T00:00:00",
                EstimatedVendorShipDate: "2019-09-18T00:00:00",
                AlternativesCount: 1,
                OrderDate: "2019-09-18T00:00:00",
            },
            {
                SalesOrganization: "MA",
                LineFacingWarehouse: "",
                OrderBranch: "15310",
                SalesOrderNumber: "7894634",
                SalesOrderLineNumber: "",
                PurchaseOrderNumber: "7890465",
                OemPartCode: "DHSJYWUC",
                QuantityOrdered: 1,
                QuantityBackordered: 1,
                OrderType: ShipmentType.Stock,
                OrderSource: Source.NotSet,
                PromisedShipDate: "2019-09-18T00:00:00",
                EstimatedVendorShipDate: "2019-09-18T00:00:00",
                AlternativesCount: 1,
                OrderDate: "2019-09-18T00:00:00",
            },
        ]);
    }

    private static getPartAlternativeResultFactory(request: AxiosRequestConfig): AxiosPromise<IPartAlternativeDto[]> {
        const code = oc(request.params as IGetPartAlternativesRequest).oemPartCode("NOT FOUND");

        switch (code) {
            case "NOT FOUND":
                return Mockios.notFound(request);
            case "A000023428":
                return Mockios.ok(request, [
                    {
                        AlternativePartId: 3901677,
                        AlternativeOemPartCode: "1050143",
                        AlternativePicCode: "601",
                        AlternativePartType: "OEM ORIGINAL",
                        DealerNetPrice: 170.79,
                        ContractPrice: 170.79,
                        BillingCurrency: "USD",
                        BillingCoreCost: 0.0,
                        PricingCoreCost: 0.0,
                        ValidationReason: PartValidationReason.IsValid,
                        SourcePartId: 4019289,
                    },
                    {
                        AlternativePartId: 3901677,
                        AlternativeOemPartCode: "219338",
                        AlternativePicCode: "601",
                        AlternativePartType: "FALCON - 12 X 5 X 9 SF STD",
                        DealerNetPrice: 74.46,
                        ContractPrice: 74.46,
                        BillingCurrency: "USD",
                        BillingCoreCost: 0.0,
                        PricingCoreCost: 0.0,
                        ValidationReason: PartValidationReason.IsValid,
                        SourcePartId: 4019289,
                    },
                    {
                        AlternativePartId: 3901677,
                        AlternativeOemPartCode: "A000003646",
                        AlternativePicCode: "601",
                        AlternativePartType: "SUPERIOR - 12 X 5 X 9 SF XL",
                        DealerNetPrice: 129.9,
                        ContractPrice: 129.9,
                        BillingCurrency: "USD",
                        BillingCoreCost: 0.0,
                        PricingCoreCost: 0.0,
                        ValidationReason: PartValidationReason.IsValid,
                        SourcePartId: 4019289,
                    },
                ]);

            case "ELSA":
                return Mockios.ok(request, [
                    {
                        AlternativePartId: 324654,
                        AlternativeOemPartCode: "DISNEY",
                        AlternativePicCode: "608",
                        AlternativePartType: "SNOWMAN",
                        DealerNetPrice: 20.01,
                        ContractPrice: 19.95,
                        BillingCurrency: "USD",
                        BillingCoreCost: 0.0,
                        PricingCoreCost: 0.0,
                        ValidationReason: PartValidationReason.IsSoftFrozen,
                        SourcePartId: 78979,
                    },
                ]);

            case "BATMAN":
                return Mockios.ok(request, [
                    {
                        AlternativePartId: 324654,
                        AlternativeOemPartCode: "Cave-B",
                        AlternativePicCode: "608",
                        AlternativePartType: "BATMOBILE",
                        DealerNetPrice: 20.01,
                        ContractPrice: 19.95,
                        BillingCurrency: "USD",
                        BillingCoreCost: 0.0,
                        PricingCoreCost: 0.0,
                        ValidationReason: PartValidationReason.IsSoftFrozen,
                        SourcePartId: 78979,
                    },
                ]);

            default:
                return Mockios.ok(request, [
                    {
                        AlternativePartId: 3901677,
                        AlternativeOemPartCode: "MD320618",
                        AlternativePicCode: "601",
                        AlternativePartType: "STARTER ORIGINIAL-NEW",
                        DealerNetPrice: 125.71,
                        ContractPrice: 125.71,
                        BillingCurrency: "USD",
                        BillingCoreCost: 0.0,
                        PricingCoreCost: 0.0,
                        ValidationReason: PartValidationReason.IsValid,
                        SourcePartId: 4019289,
                    },
                ]);
        }
    }
}
